import React, { Component } from 'react';
import cl from 'classnames';
import PropTypes from 'prop-types';

export default class Marker extends Component {
    render() {
        const { isSecondaryColor } = this.props;
        return (
            <div
                className={cl({
                    'ui-marker': true,
                    'ui-marker--alt': isSecondaryColor,
                })}
            />
        );
    }
}

Marker.defaultProps = {
    isSecondaryColor: false,
};
Marker.propTypes = {
    isSecondaryColor: PropTypes.bool,
};
